/**
 * Created by rickborst on 25/04/2017.
 */

const ImageRatios = {
    '16:9': '16:9',
    '3:2': '3:2',
    '2:3': '2:3',
    '1:1': '1:1'
};

class Image {

    constructor (options = {}) {

        this.id = options.id || '';
        this.height = options.height || null;
        this.width = options.width || null;
        this.ratio = options.ratio || '';
        this.url = options.url || '';
        this.apiSpecifics = options.apiSpecifics || {};

        return this;
    }
}

export {ImageRatios};
export default Image;


// WEBPACK FOOTER //
// ./src/js/models/image.js